<div class="table-responsive">
	<table class="table table-hover table-sortable">
		<thead class="thead-light">
		<tr>
			@if (columns.firstName !== false) {
				<th class="col-firstName is-sortable" translate="DataList.Columns.FirstName"
					[ngClass]="getSortClasses(sortCols.FIRSTNAME)" (click)="setSort(sortCols.FIRSTNAME)">
				</th>
			}
			@if (columns.lastName !== false) {
				<th class="col-lastName is-sortable" translate="DataList.Columns.LastName"
					[ngClass]="getSortClasses(sortCols.LASTNAME)" (click)="setSort(sortCols.LASTNAME)">
				</th>
			}
			@if (columns.userName !== false) {
				<th class="col-userName is-sortable" translate="DataList.Columns.UserName"
					[ngClass]="getSortClasses(sortCols.USERNAME)" (click)="setSort(sortCols.USERNAME)">
				</th>
			}
			@if (columns.email !== false) {
				<th class="col-userName is-sortable" translate="DataList.Columns.UserName"
					[ngClass]="getSortClasses(sortCols.EMAIL)" (click)="setSort(sortCols.EMAIL)">
				</th>
			}
			@if (columns.subsidiaryRole !== false) {
				<th class="col-subsidiaryRole" translate="DataList.Columns.SubsidiaryRole">
				</th>
			}
			@if (columns.delegation !== false) {
				<th class="col-delegation is-sortable" translate="DataList.Columns.UserStatus"
					[ngClass]="getSortClasses(sortCols.USERSTATUS)" (click)="setSort(sortCols.USERSTATUS)">
				</th>
			}
			@if (columns.lastConnection !== false) {
				<th class="col-lastConnection is-sortable" translate="DataList.Columns.LastConnection"
					[ngClass]="getSortClasses(sortCols.LASTCONNECTION)" (click)="setSort(sortCols.LASTCONNECTION)">
				</th>
			}
			@if (columns.actions !== false) {
				<th class="col-actions" translate="DataList.Columns.UserStatus"></th>
			}
		</tr>
		</thead>
		<tbody>
			@for (item of list.items; track item) {
				<tr>
					@if (columns.firstName !== false) {
						<td class="col-firstName">
							{{ item.firstName ? item.firstName : '-'}}
						</td>
					}
					@if (columns.lastName !== false) {
						<td class="col-lastName">{{ item.lastName ? item.lastName : '-'}}</td>
					}
					@if (columns.userName !== false || columns.email !== false) {
						<td class="col-userName">{{item.userName ? item.userName : '-'}}</td>
					}
					@if (columns.subsidiaryRole !== false) {
						<td class="col-subsidiaryRole">
							<div>
								@if (roleUnknown(item.subsidiaryRole)) {
									<div class="unknownRole">
										{{ item.subsidiaryRole }}
									</div>
								}
								<span>
									@if (!item.isCurrentUser && item.userStatus !== userStatus.Inactive) {
										<div (click)="roleMenu.open()">
											<i class="far fa-edit"></i>
										</div>
									}
									<div ngbDropdown placement="bottom-right" container="body" #roleMenu="ngbDropdown">
										{{ ('Roles.' + (item.subsidiaryRole| uppercase)) | translate }}
										<div class="dropdown-menu" ngbDropdownMenu>
											@for (role of roles; track role) {
												<button
													ngbDropdownItem
													placement="right"
													class="dropdown-item"
													(click)="changeSubsidiaryRole(item.userId, role)">
													{{ ('Roles.' + (role | uppercase)) | translate }}
												</button>
											}
										</div>
										<span class="invisible" ngbDropdownAnchor></span>
									</div>
								</span>
							</div>
						</td>
					}
					@if (columns.delegation !== false) {
						<td class="col-delegation">
							<middle-users-status-actions
								[user]="item"
								(changeStatus)="changeUserStatus(item.userId, $event)"
								(viewDelegation)="onOpenDelegationView(item)"
								(editDelegation)="onOpenDelegationForm(item)"
								(editInactivity)="onOpenInactivityForm(item)"
								(sendRegistrationRequest)="resendRegistrationRequest(item.userId)"
							/>
						</td>
					}
					@if (columns.lastConnection !== false) {
						<td class="col-lastConnection">
							{{ (item.lastConnection | dateFormat: 'WithHours2') || '-' }}
						</td>
					}
					@if (columns.actions !== false) {
						<td class="col-actions">
							@if ({ isActive: item.userStatus === userStatus.Active }; as status) {
								<div [class.ml-5]="item.isCurrentUser">
									@if (!item.isCurrentUser) {
										<button
										class="btn"
										type="button"
										container="body"
										[ngbTooltip]="(status.isActive ? 'Actions.Disable' : 'Actions.Activate') | translate"
										(click)="onToggleInactivity(item, !status.isActive)"
										><i class="far"
										[class.fa-user]="item.userStatus === userStatus.Inactive"
										[class.fa-user-slash]="item.userStatus === userStatus.Active"
										></i></button>
									}
									<span
									class="user-status-label"
									[translate]="status.isActive ? 'DataList.Columns.Active' : 'DataList.Columns.Inactive'"
									></span>
								</div>
							}
						</td>
					}
				</tr>
			} @empty {
				<tr table-row-empty></tr>
			}
		</tbody>
	</table>
</div>
